export default __webpack_public_path__ + "static/media/learning_center.9ed989f2.svg";